import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DropdownItem } from 'projects/admin/src/app/models/commonModel';
import { LoginService } from 'projects/admin/src/app/services/login.service';
import { Subscription, forkJoin } from 'rxjs';
import { ExternalCommonService } from '../../shared/services/external.common.service';
import { ExternalDocumentService } from '../../shared/services/externalDocument.service';

@Component({
  selector: 'app-upload-tab',
  templateUrl: './upload-tab.component.html',
  styleUrls: ['./upload-tab.component.scss']
})
export class UploadTabComponent implements OnInit {
  @Input()
  SavedUploadMode: any;
  requestId: any;
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = [
    'fileName',
    'documentTypes',
  ];
  editUserRoles = ['X2FhZml9eHxzcGlgaGZj', 'X2FhZmkjfiR4JyN0ISYkaWBoZmM=', 'X2FhZmkjfiVwfXhzI35+cmlgaGZj'];
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  file: File | undefined;
  progress = 0;
  uploadType: any;
  uploadSub!: Subscription;
  doctypeControl = new FormControl([]);
  paymentAndUploadMode = -1;
  docTypeList: DropdownItem[] = [];
  @Output() onPaymentUploadTypeChange: EventEmitter<any> = new EventEmitter();
  constructor( private router: ActivatedRoute,
    private commonService: ExternalCommonService,
    private loginService: LoginService,
    private exemptionDocumentService: ExternalDocumentService,
    private toastr: ToastrService,
    private routerService: Router) { }

  ngOnInit(): void {
    this.requestId = atob(this.router.snapshot.params.id);
    this.loadTypesData();
    this.loadData();
    this.paymentAndUploadMode = this.SavedUploadMode;
  }

  onFileSelected(event: any) {
    this.file = event.target.files[0];
  }

  onCheck(value: number) {
    this.paymentAndUploadMode = value;
    this.onPaymentUploadTypeChange.emit(this.paymentAndUploadMode);
  }

  onDocRemoved(doc: string) {
    const doctype = this.doctypeControl.value as string[];
    this.removeFirst(doctype, doc);
    this.doctypeControl.setValue(doctype);
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  private loadTypesData() {
    this.commonService.getDocumentImageType().subscribe((res) => {
      this.docTypeList = res;
    });
  }


  private loadData() {
    forkJoin({
      documents: this.exemptionDocumentService.getDocuments(this.requestId),
    }).subscribe(({ documents }) => {
      documents.map((obj: any) => {
        obj.description = "";
        obj.documentImageTypeIds.forEach((id: string | Blob) => {
          if (obj.description.length > 0) obj.description += ', '
          obj.description += this.docTypeList.find((x: any) => x.id == id)?.description;
        });
        
        return obj;
      });
      this.dataSource = new MatTableDataSource(documents);
    });
  }
  onSave() {
    const selectedDocTypes = this.doctypeControl.value.map((a: { id: any; }) => a.id);
    if (this.file) {
      console.log(this.file.size);
      

      const fileName = this.file.name;
      const formData = new FormData();
      formData.append('file', this.file);
      selectedDocTypes.forEach((id: string | Blob) => {
        formData.append('documentImageTypeId', id);
      });
      formData.append('replicaPath', this.file.type);
      formData.append('indictorNumber', '1');
      formData.append('isCurrent', 'false');
      this.progress = 0;
      this.exemptionDocumentService
        .uploadDocument(this.requestId, formData)
        .subscribe({
          next: (event: any) => {
            if (event.type === HttpEventType.UploadProgress) {
              this.progress = Math.round((100 * event.loaded) / event.total);
            } else if (event instanceof HttpResponse) {
              this.progress = 0;
              this.toastr.success('File uploaded succesfully.', 'success', {
                positionClass: 'toast-top-center',
                timeOut: 3000,
              });
              this.loadData();
            }
          },
          error: (err: any) => {
            console.log(err);
            this.progress = 0;
            this.toastr.error(
              'Error occured while uploading document.',
              'Error',
              {
                positionClass: 'toast-top-center',
                timeOut: 3000,
              }
            );
          },
        });
    }
  }
}
